export default __webpack_public_path__ + "static/media/6994619-uhd_3840_2160_30fps.a2d8dae9.mp4";